'use client';
import type {SxProps, Theme} from '@mui/material/styles';
import type {ReactNode} from 'react';
import {Typography, type TypographyTag} from './Typography';

export type SectionTitleTone = 'default' | 'inverse';

export type SectionTitleSx = Exclude<Extract<SxProps<Theme>, readonly unknown[]>[number], boolean | undefined>;

export interface SectionTitleProps {
  children?: ReactNode;
  as?: TypographyTag;
  tone?: SectionTitleTone;
  sx?: SectionTitleSx;
}

export function SectionTitle({children, as = 'h2', tone = 'default', sx}: SectionTitleProps) {
  const base: SectionTitleSx = {
    textTransform: 'capitalize',
    color: theme => ({default: theme.palette.colors.text.neutral.strong, inverse: theme.palette.colors.text.neutral.inverse})[tone],
  };
  return (
    <Typography size="title-5" weight="semiBold" mobileSize="title-6" mobileWeight="semiBold" as={as} sx={sx ? [base, sx] : base}>
      {children}
    </Typography>
  );
}

SectionTitle.displayName = 'SectionTitle';
